module.exports = __webpack_public_path__ + "img/goodbj.16765db5.png";